import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/bell-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5d5c727e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manual-intervention-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manual-intervention-modal__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "icon"
  })
], -1))
const _hoisted_3 = { class: "manual-intervention-modal__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "SLA Time (Manual Intervention)", -1))
const _hoisted_5 = { class: "manual-intervention-modal__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    class: "tw-max-w-[544px]",
    isShowCloseButton: false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString($props.issueDetail.user.firstName) + " " + _toDisplayString($props.issueDetail.user.lastName), 1),
            _createTextVNode(" has raised an emergency out-of-hours Issue "),
            _createElementVNode("strong", null, _toDisplayString($props.issueDetail.title), 1),
            _createTextVNode(" Would you like to intervene? ")
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_btn, {
            class: "button button-purple-border",
            block: "",
            onClick: $setup.onClickNoIntervene,
            disabled: $props.isLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode("No, I Don't Want to Intervene")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_v_btn, {
            class: "button button-orange",
            block: "",
            onClick: $setup.onClickManualIntervention,
            loading: $props.isLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode("Yes, I want to Intervene")
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ])
    ]),
    _: 1
  }))
}